import React from 'react';
import { Layout } from 'antd';
import { useThemeStyles } from '../context/ThemeContext';
import { getThemeStyles } from '../theme';
import packageJson from '../../package.json';

const { Footer: AntFooter } = Layout;

const Footer = ({ forcePublicDark = false }) => {
  const ctxStyles = useThemeStyles();
  const themeStyles = forcePublicDark ? getThemeStyles('dark') : ctxStyles;
  const version = packageJson.version;

  return (
    <AntFooter
      className={forcePublicDark ? 'footer-force-public-dark' : undefined}
      style={{
        background: themeStyles.footerBg,
        borderTop: `1px solid ${themeStyles.borderColor}`,
        padding: '6px 24px',
        textAlign: 'center',
        color: themeStyles.footerMuted,
        fontSize: '12px',
        flexShrink: 0,
        minHeight: '28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      © Enterprise AI Platform. All Rights Reserved. | Version {version}
    </AntFooter>
  );
};

export default Footer;

